import { Component } from '@angular/core';
import {
  SYSTEM_PROPERTY_NOTIFIER,
  SYSTEM_PROPERTY_REPORT_FILENAME,
  SYSTEM_PROPERTY_SERVICE
} from '@nucleus/system-property-ui';
import {
  TasksenseSystemPropertyNotifierAdapter,
  TasksenseSystemPropertyServiceAdapter
} from './system-property.adapter';

/**
 * NUC-274: tasksense thin shell over @nucleus/system-property-ui. Heavy
 * lifting (registry tree + list + value-editor dialog) lives in the
 * shared lib. This component just registers the tenant adapters via DI
 * providers and renders <lib-system-property>. Access is gated by the
 * shared CAPABILITY_CHECKER (wired app-wide to PermissionsService) — the
 * lib resolves SystemPropertyCaps codes itself.
 */
@Component({
  selector: 'system-property',
  templateUrl: './system-property.component.html',
  styleUrl: './system-property.component.css',
  standalone: false,
  providers: [
    { provide: SYSTEM_PROPERTY_SERVICE,         useExisting: TasksenseSystemPropertyServiceAdapter },
    { provide: SYSTEM_PROPERTY_NOTIFIER,        useClass:    TasksenseSystemPropertyNotifierAdapter },
    { provide: SYSTEM_PROPERTY_REPORT_FILENAME, useValue:    'tasksense' },
  ]
})
export class SystemPropertyComponent { }
